import { connect } from 'react-redux';
import { IMortgageLandingProps, MortgageLanding } from '../../components/MortgageLanding';
import { IReduxState } from '../../types/redux';
import { parseRealtyType } from './RealtyTypeParser';

export const mapStateToProps = ({ mortgage }: IReduxState): IMortgageLandingProps => {
  return {
    initialpayment: mortgage.filterDownPayment,
    propertyamount: mortgage.filterRealtyPrice,
    loanterm: mortgage.filterTerms,
    realtytype: parseRealtyType(mortgage.filterBuildingType),
    regionid: mortgage.filterRegionId,
    pagetype: 'frontend_mainpage',
    tooltipexperiment: true,
  };
};

export const MortgageLandingContainer = connect(mapStateToProps)(MortgageLanding);
